import { render, staticRenderFns } from "./ActionDiagnosticar.vue?vue&type=template&id=623c1ce9&scoped=true&lang=pug"
import script from "./ActionDiagnosticar.vue?vue&type=script&lang=js"
export * from "./ActionDiagnosticar.vue?vue&type=script&lang=js"
import style0 from "./ActionDiagnosticar.vue?vue&type=style&index=0&id=623c1ce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c1ce9",
  null
  
)

export default component.exports